import { render } from "./myClient.vue?vue&type=template&id=56da33a5&ts=true"
import script from "./myClient.vue?vue&type=script&lang=ts&config=true"
export * from "./myClient.vue?vue&type=script&lang=ts&config=true"

import "./myClient.vue?vue&type=style&index=0&id=56da33a5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__